var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcMouse = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "18px",
    viewBox: "0 0 12 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_chevron_right copy 3")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "vcxzvxzc",
    x: 0,
    y: 0,
    width: 1170,
    height: 382,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.0%",
    y: "-2.0%",
    width: "102.0%",
    height: "106.0%",
    filterUnits: "objectBoundingBox",
    id: "ffdsagfdgfs"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "qrwerdsafdsafger",
    x: 0,
    y: 0,
    width: 1170,
    height: 68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,0.8025 L9.75,6.75 L15,6.75 C15,3.69 12.7125,1.17 9.75,0.8025 L9.75,0.8025 Z M3,11.25 C3,14.565 5.685,17.25 9,17.25 C12.315,17.25 15,14.565 15,11.25 L15,8.25 L3,8.25 L3,11.25 L3,11.25 Z M8.25,0.8025 C5.2875,1.17 3,3.69 3,6.75 L8.25,6.75 L8.25,0.8025 L8.25,0.8025 Z",
    id: "pathe4eek"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "pathe4eek2",
    x: 0,
    y: 0,
    width: 37.5,
    height: 37.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "updatesssss34",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "updatesss21",
    transform: "translate(-1123.000000, -211.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 901
  }), /*#__PURE__*/React.createElement("g", {
    id: "table",
    transform: "translate(250.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "shoowmassk",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vcxzvxzc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellloon"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#ffdsagfdgfs)",
    xlinkHref: "#vcxzvxzc"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#DFE2E5",
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#vcxzvxzc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "updatesss210",
    mask: "url(#shoowmassk)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "shoowmasskig",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qrwerdsafdsafger"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ellloon",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#qrwerdsafdsafger"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sosomitch-10",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#shoowmasskig)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(644.000000, 25.000000)",
    id: "sosomitch-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_chevron_right-copy-3",
    transform: "translate(226.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qqqqqokaitsmask",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pathe4eek"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellloon"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sosomitch",
    mask: "url(#qqqqqokaitsmask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.750000, -9.750000)",
    id: "coloreeeeew"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pathe4eek2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ouuuumai",
    fill: "#F5A623",
    xlinkHref: "#pathe4eek2"
  })))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcMouse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-mouse.9e7fe659.svg";
export { ForwardRef as ReactComponent };